import { bunja } from 'bunja';
import { atom } from 'jotai';

import { walletsBunja } from '@flipster/r230522/original/wallet';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { isEarnSunsetHolder } from '@flipster/utils/earn-sunset';
import { getFlipsterConfigsV1Key, getLocalStorage, setLocalStorage } from '@flipster/utils/localStorage';

import { authBunja } from '../../shared/auth/state';
import { earnSunsetPhaseBunja } from './phase-bunja';

export const earnSunsetBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { isLoggedInAtom, userIdAtom } = bunja.use(authBunja);
  const { phaseAtom } = bunja.use(earnSunsetPhaseBunja);
  const { walletsAtom } = bunja.use(walletsBunja);

  const dismissVersionAtom = atom(0);

  const dismissedAtom = atom((get) => {
    get(dismissVersionAtom);
    const userId = get(userIdAtom);
    if (userId == null) return false;
    return getLocalStorage(getFlipsterConfigsV1Key(userId, 'skipEarnSunsetModal')) === true;
  });

  const isHolderAtom = atom((get) => isEarnSunsetHolder(get(walletsAtom)));

  const shouldShowSunsetModalAtom = atom((get) => {
    return get(isLoggedInAtom) && get(phaseAtom) === 'buffer' && get(isHolderAtom) && !get(dismissedAtom);
  });

  function persistDismiss() {
    const userId = store.get(userIdAtom);
    if (userId == null) return;
    setLocalStorage(getFlipsterConfigsV1Key(userId, 'skipEarnSunsetModal'), true);
    store.set(dismissVersionAtom, store.get(dismissVersionAtom) + 1);
  }

  return {
    phaseAtom,
    isHolderAtom,
    dismissedAtom,
    shouldShowSunsetModalAtom,
    persistDismiss,
  };
});
earnSunsetBunja.debugLabel = 'earnSunsetBunja';
